import { _ } from '@ngx-translate/core';
import { PressureUnit } from '@app/shared/units/pressure/pressure-unit.enum';

export const pressureUnitLocalize: Record<PressureUnit, string> = {
  [PressureUnit.Bar]: _(`@@shared-pressure-unit__bar`),
  [PressureUnit.Kilopascal]: _(`@@shared-pressure-unit__kpa`),
  [PressureUnit.Psi]: _(`@@shared-pressure-unit__psi`),
  [PressureUnit.MetresHead]: _(`@@shared-pressure-unit__metres-head`),
  [PressureUnit.FeetHead]: _(`@@shared-pressure-unit__feet-head`),
};

/** the unit the API stores pressure in, and the field's default */
export const DEFAULT_PRESSURE_UNIT = PressureUnit.Bar;
